import { UseMutationOptions, UseMutationResult, useMutation } from 'react-query';
import { axiosClient, url } from '../';
import { AxiosError } from 'axios';
import { ErrorObject } from './../common.types';

export function useSubmitKYB<TContext>(
  options?: Omit<UseMutationOptions<void, AxiosError<ErrorObject>, void, TContext>, 'mutationKey' | 'mutationFn'>,
): UseMutationResult<void, AxiosError<ErrorObject>, void, TContext> {
  const key = ['SubmitKYB'];

  return useMutation(() => axiosClient.post(url.kybController.submitKYB), {
    ...options,
    mutationKey: key,
  });
}
